var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckmarkYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-checkmark-grey"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.49755 3.5329L5.72039 6.50485L12.7802 0L15.2778 2.30313L8.2238 8.80798L5.72039 11.1111L3.22284 8.80798L0 5.83603L2.49755 3.5329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49755 3.5329L5.72039 6.50485L12.7802 0L15.2778 2.30313L8.2238 8.80798L5.72039 11.1111L3.22284 8.80798L0 5.83603L2.49755 3.5329Z",
    fill: "url(#paint0_linear_1998_17770)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1998_17770",
    x1: 7.63889,
    y1: -5.55556,
    x2: -2.93168,
    y2: 8.97898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECD5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BB33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkYellow);
export default __webpack_public_path__ + "static/media/icon-checkmark-yellow.0d37ec4be16cd8bf46e47260fb18349f.svg";
export { ForwardRef as ReactComponent };